<div class="confirm-totp">
  <div class="card">
    <form
      class="k-form k-form-md"
      [formGroup]="mfaForm"
      (ngSubmit)="confirmMfa()"
    >
      <div class="form-field">
        <div class="top">
          <span class="title"><b>MFA - AutoForm Cloud</b></span>
        </div>
        <div class="login-box">
          <div class="login-items">
            <kendo-formfield>
              <kendo-label [for]="code" text="MFA Code"></kendo-label>
              <kendo-textbox formControlName="code" #code> </kendo-textbox>
            </kendo-formfield>
            @if(errorMessage) {
            <af-form-error [message]="errorMessage"></af-form-error>
            }
            <div class="k-form-buttons">
              <button kendoButton>OK</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
